(() => {
  if (!customElements.get('jf-mix-order')) {
    customElements.define('jf-mix-order', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.inputs = [...this.querySelectorAll('input[data-variant-id]')];
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[data-jf-status]');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-ZA', {style: 'currency', currency: this.dataset.currency || 'ZAR', currencyDisplay:'narrowSymbol'});
        this.form.addEventListener('input', () => this.update());
        this.form.addEventListener('submit', event => this.add(event));
        this.presetButtons = [...this.querySelectorAll('[data-jf-preset]')];
        this.presetStatus = this.querySelector('[data-jf-pack-status]');
        this.undoButton = this.querySelector('[data-jf-undo]');
        this.presetButtons.forEach(button => {
          const plan = this.presetPlan(button);
          button.dataset.available = String(!!plan);
          const price = button.closest('.jf-pack-card').querySelector('[data-jf-pack-price]');
          price.textContent = plan ? this.money.format(plan.reduce((sum, item) => sum + Number(item.input.dataset.price) * item.quantity, 0) / 100) : this.dataset.unavailable;
          button.addEventListener('click', () => this.applyPreset(button));
        });
        this.undoButton?.addEventListener('click', () => {
          if (this.busy || !this.previousSelection) return;
          this.inputs.forEach((input, index) => { input.value = this.previousSelection[index]; });
          this.previousSelection = null;
          this.undoButton.hidden = true;
          this.presetStatus.textContent = this.dataset.undone;
          this.update();
        });
        this.hidden = false;
        this.update();
      }
      presetPlan(button) {
        const quantities = JSON.parse(button.dataset.jfPreset);
        const preferred = {'energy-gel':'Chocolate','bottle-mix':'Orange','hydrate':'Mix Pack','recover-shake':'Chocolate'};
        const plan = [];
        for (const [handle, quantity] of Object.entries(quantities)) {
          if (!Number.isSafeInteger(quantity) || quantity < 0) return null;
          if (!quantity) continue;
          const available = this.inputs.filter(input => input.dataset.productHandle === handle && !input.disabled && !(handle === 'energy-gel' && /boost/i.test(input.dataset.variantTitle)));
          const input = available.find(input => input.dataset.variantTitle.toLowerCase() === preferred[handle]?.toLowerCase()) || available[0];
          if (!input) return null;
          plan.push({input, quantity});
        }
        return plan.length ? plan : null;
      }
      applyPreset(button) {
        if (this.busy) return;
        const plan = this.presetPlan(button);
        if (!plan) { this.presetStatus.textContent = this.dataset.unavailable; return; }
        this.previousSelection = this.inputs.map(input => input.value);
        this.inputs.forEach(input => { input.value = '0'; });
        plan.forEach(({input, quantity}) => { input.value = String(quantity); input.closest('details').open = true; });
        this.status.textContent = '';
        this.undoButton.hidden = false;
        this.presetStatus.textContent = button.dataset.jfName + ': ' + this.dataset.selected;
        this.update();
        const first = plan[0].input;
        first.scrollIntoView({block:'center', behavior:'instant'});
        first.focus({preventScroll:true});
      }
      selection() {
        return this.inputs.filter(input => !input.disabled && Number.isSafeInteger(input.valueAsNumber) && input.valueAsNumber > 0)
          .map(input => ({id: input.dataset.variantId, quantity: input.valueAsNumber, price: Number(input.dataset.price)}));
      }
      update() {
        const items = this.selection();
        const count = items.reduce((sum, item) => sum + item.quantity, 0);
        const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
        this.querySelector('[data-jf-count]').textContent = count;
        this.querySelector('[data-jf-total]').textContent = this.money.format(total / 100);
        this.button.disabled = this.busy || !count || !this.form.checkValidity();
        this.inputs.forEach(input => { input.readOnly = !!this.busy; });
        this.presetButtons?.forEach(button => { button.disabled = !!this.busy || button.dataset.available !== 'true'; });
        if (this.undoButton) this.undoButton.disabled = !!this.busy;
      }
      async add(event) {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        const selected = this.selection();
        if (!selected.length) { this.status.textContent = this.dataset.empty; return; }
        this.busy = true;
        this.button.textContent = this.dataset.adding;
        this.status.textContent = '';
        this.setAttribute('aria-busy', 'true');
        this.update();
        const cart = document.querySelector('cart-drawer');
        const root = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: {'Content-Type':'application/json', 'Accept':'application/json'},
            body: JSON.stringify({items: selected.map(({id, quantity}) => ({id, quantity})), sections: ['cart-drawer','cart-icon-bubble'], sections_url: window.location.pathname})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          added = true;
          this.inputs.forEach(input => { input.value = 0; });
          this.previousSelection = null;
          if (this.undoButton) this.undoButton.hidden = true;
          if (this.presetStatus) this.presetStatus.textContent = '';
          this.status.textContent = this.dataset.success;
          if (cart && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
            cart.classList.remove('is-empty');
            cart.setActiveElement(this.button);
            cart.renderContents(result);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'jf-mix-order'});
          } else {
            window.location.assign(root + 'cart');
          }
        } catch (error) {
          if (added) window.location.assign(root + 'cart');
          else this.status.textContent = error.message && error.message !== this.dataset.error ? error.message + ' ' + this.dataset.error : this.dataset.error;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.button.textContent = this.dataset.submit;
          this.update();
        }
      }
    });
  }
  if (!customElements.get('jf-sticky-purchase')) {
    customElements.define('jf-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.original = this.form?.querySelector('[type="submit"]');
        if (!this.original) return;
        this.button = this.querySelector('[data-jf-buy]');
        this.selectionLabel = this.querySelector('[data-jf-selection]');
        this.info = this.closest('product-info');
        this.refresh = () => {
          this.hidden = this.original.getBoundingClientRect().bottom >= 0;
          this.button.disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
          this.button.textContent = this.original.querySelector('span')?.textContent.trim() || this.original.textContent.trim();
          const options = [...(this.info?.querySelectorAll('variant-selects input:checked, variant-selects option:checked') || [])].map(input => input.value).join(' / ');
          const price = this.info?.querySelector('.price .price-item--regular')?.textContent.trim() || '';
          const quantity = this.info?.querySelector('input[name="quantity"]')?.value || '1';
          const nextLabel = [options, price, '× ' + quantity].filter(Boolean).join(' · ');
          if (this.selectionLabel.textContent !== nextLabel) this.selectionLabel.textContent = nextLabel;
        };
        this.button.addEventListener('click', () => { if (!this.button.disabled) this.form.requestSubmit(this.original); });
        this.onScroll = () => this.refresh();
        window.addEventListener('scroll', this.onScroll, {passive: true});
        this.info?.addEventListener('change', this.onScroll);
        this.observer = new MutationObserver(this.refresh);
        this.observer.observe(this.original, {attributes:true, childList:true, subtree:true});
        this.refresh();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.info?.removeEventListener('change', this.onScroll);
        this.observer?.disconnect();
      }
    });
  }
})();
